import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-amazon-advertising-checklist',
  templateUrl: './help-amazon-advertising-checklist.component.html'
})
export class HelpAmazonAdvertisingChecklistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
